// extracted by mini-css-extract-plugin
module.exports = {"username":"_2qlfOpCa8uyg3R0cdeqpkz","text":"ENmgVa6EMIEPNeS2sicVC"};